<template>
  <div class="relative flex justify-center">
    <div
      :style="{ height, width: height }"
      class="absolute rounded-full opacity-50 bg-slate-300"
    ></div>
    <PieChart
      :key="'analytics-pie-chart'"
      :options="chartOptions"
      :chart-data="chartCollection"
      class="z-10"
      :style="{
        height,
        width: `calc(${height} + ${height})`
      }"
    />
  </div>
</template>

<script>
import PieChart from "../../charts/PieChart";

export default {
  name: "AnalyticsPieChart",
  components: { PieChart },
  props: {
    labels: { type: Array, default: () => ["no label"] },
    colors: { type: Array, default: () => [] },
    data: { type: Array, default: () => [1] },
    height: { type: String, default: "10rem" }
  },
  data() {
    return {};
  },
  computed: {
    chartOptions() {
      return {
        legend: { display: false },
        maintainAspectRatio: false
      };
    },
    chartCollection() {
      return {
        datasets: [
          {
            backgroundColor: this.colors,
            data: this.data
          }
        ],
        labels: this.labels
      };
    }
  },
  watch: {},
  mounted() {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/analytics/graphs/PieChart.vue